module.exports = __webpack_public_path__ + "static/media/YulyaSlide.e46f5eee.jpg";